import {Layout, Divider, Image, Space, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;
const Uno = () => {
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className='Title2' style={{color: appColors['ColorNa']}}>Project Description</Paragraph>
        <Paragraph className='Title3' style={{color: appColors['ColorX'], marginTop: '-8vh'}}>Aging as a healthcare priority</Paragraph>
        <Space size={80} align="center" style={{background: 'inherit', width: 'fit-content', marginTop: '-2%'}}>
          <Content style={{float: 'left', background: 'inherit', marginTop: '6%'}}>
            <Text className='BaseText5'>In the last century, there has been an important increase in <b>life expectancy</b> at a global level. This is a reflection of substantial health improvements and should be considered as one of the greatest achievements of our time. However, this also means that the populations will age at a faster pace in the near future, inverting the population pyramids in a way that has never been seen before.</Text>
          </Content>
          <Content style={{width: 'fit-content', display: 'block', marginTop: '3%', background: 'transparent'}}>
            <Image src='https://static.igem.wiki/teams/4464/wiki/project-description/1gif-life-expectancy.gif' preview={false}/>
            <p>Fig 1. Life Expectancy worldwide from 1770-1990</p>
          </Content>
        </Space>
        <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '3vh', textAlign: 'center', marginTop: '4%'}}>A pyramid inversion never seen before</Paragraph>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '80%', background: 'inherit', marginTop: '0%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/project-description/2-population-pyramid.gif' preview={false}/>
          <p>Fig 2. Population pyramid (age structure) in Mexico</p>
        </Content>
        <Text className='BaseText2' style={{marginTop: '2%'}}>Because of this, by 2030 <b> 1 out of 6 people will be 60 years or older</b> and by 2050, the number of older adults (65 years+) worldwide will increase from 137 million to<b>  425</b> million. Additionally, about<b> 80%</b> of them will live in low- and middle-income countries [3]. </Text>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '80%', background: 'inherit', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/project-description/3-timeline.png' preview={false}/>
          <p>Fig. 3 Timeline of key events related to aging from 1800 to 2100</p>
        </Content>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default Uno;
